import type { MarketSelectorValue } from '../../../../MarketSelector/types';
import type { PrimeRFQParams } from '../../../../OMS/NewRFQ/types';
import { getPrimeOrderMarketParams } from '../primeOrder/getPrimeOrderMarketParams';

export function getPrimeRFQParams({
  symbol,
  orderQty,
  subAccount,
  marketSelectorValue,
  marketsByName,
  marketAccountsByName,
}: {
  symbol: string;
  orderQty?: string;
  subAccount?: string;
  marketSelectorValue: MarketSelectorValue | undefined;
  marketsByName: ReadonlyMap<string, unknown>;
  marketAccountsByName: ReadonlyMap<string, unknown>;
}): PrimeRFQParams {
  const { selectedMarketAccounts, selectedMarkets, selectedAggregation } = getPrimeOrderMarketParams({
    marketSelectorValue,
    marketsByName,
    marketAccountsByName,
  });
  const selectedMarketItems = [...selectedMarketAccounts, ...selectedMarkets];

  return {
    symbol,
    orderQty,
    ...(selectedMarketItems.length > 0 ? { marketAccounts: selectedMarketItems } : {}),
    ...(selectedAggregation ? { aggregation: selectedAggregation } : {}),
    ...(subAccount ? { subAccount } : {}),
  };
}
